import { AvailableLocale } from '@omnea-digital/toolbox'
import { COMPACT_NUMBER_FORMAT, formatNumber, formatNumberAbbreviated, type NumericUnit } from '@omnea-app/insights/numberFormat'
import { getCurrencySymbol, getCurrencySymbolPosition } from '@omnea-app/packages/universal/currency-utils/formatCurrency'

export { formatNumber, formatNumberAbbreviated, type NumericUnit } from '@omnea-app/insights/numberFormat'

/** The field's currency symbol and which side of the digits the locale writes it on; null for a unitless field. */
export type UnitAdornment = { symbol: string; position: 'start' | 'end' }

export const unitAdornmentFor = (unit: NumericUnit, locale: AvailableLocale): UnitAdornment | null =>
  unit === null ? null : { symbol: getCurrencySymbol(unit, locale), position: getCurrencySymbolPosition(unit, locale) }

// "1.3k" for 1,250 reads as a different number from the one a filter compares against, so a value
// is only abbreviated when the short form loses nothing, and is written in full otherwise.
export const formatNumberAbbreviatedIfExact = (value: number, locale: AvailableLocale): string => {
  const abbreviated = formatNumberAbbreviated(value, null, locale)
  const unrounded = new Intl.NumberFormat(locale, { ...COMPACT_NUMBER_FORMAT, maximumFractionDigits: 20 }).format(value)
  return abbreviated === unrounded ? abbreviated : formatNumber(value, null, locale)
}
